import styled, { css } from 'styled-components';
import { CloseBold16 } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { getColorWithAlpha, getInvertedColor } from '@elfsight/widget-utils';

type BarCloseControlProps = {
  color?: string;
  onClick(): void;
};

export function BarCloseControl({
  color = 'rgb(255, 255, 255)',
  onClick
}: BarCloseControlProps) {
  return (
    <BarCloseControlContainer
      _invertedColor={getInvertedColor(color)}
      aria-label="Close"
      onClick={onClick}
    >
      <Icon component={CloseBold16} size={16} fill={color} />
    </BarCloseControlContainer>
  );
}

export const BarCloseControlContainer = styled.button<{
  _invertedColor: string;
}>`
  ${({ _invertedColor }) => css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    background-color: ${getColorWithAlpha(_invertedColor, 0.5)};
    transition: background-color 0.3s ease;

    &:hover,
    &:focus {
      background-color: ${getColorWithAlpha(_invertedColor, 0.7)};
    }

    &:active {
      background-color: ${getColorWithAlpha(_invertedColor, 0.3)};
    }
  `}
`;
